import PropTypes from 'prop-types'
import React from 'react'
import CloseIcon from '../../../../assets/CloseIcon'
import autoBookingStyles from './autoBookingPopover.css'

const CloseButton = ({
  onClose,
}) => (
  <button className={autoBookingStyles.close} onClick={onClose}>
    <CloseIcon />
  </button>
)

CloseButton.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default CloseButton



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/BookingPopover/AutoBookingPopover/CloseButton.js